module.exports = __webpack_public_path__ + "img/sandClock.a02651c1.svg";